export const APP = {
    TOGGLE_422_PASSWORD_RESET: 'TOGGLE_422_PASSWORD_RESET',
    TOGGLE_PASSWORD_UPDATE_VIEW: 'TOGGLE_PASSWORD_UPDATE_VIEW',
    GET_FSDO_LOCATIONS_PENDING: 'GET_FSDO_LOCATIONS_PENDING',
    GET_FSDO_LOCATIONS_SUCCESS: 'GET_FSDO_LOCATIONS_SUCCESS',
    GET_FSDO_LOCATIONS_FAILURE: 'GET_FSDO_LOCATIONS_FAILURE',
    ON_CLICK_GET_REQUEST: 'ON_CLICK_GET_REQUEST',
    ON_CLICK_GET_SUCCESS: 'ON_CLICK_GET_SUCCESS',
    ON_CLICK_GET_FAILURE: 'ON_CLICK_GET_FAILURE',
    SET_PORTAL_TYPE: 'SET_PORTAL_TYPE',
    REQUEST: {
        REGISTRATION: {
            RESET: 'REGISTRATION_REQUEST_RESET',
            PENDING: 'REGISTRATION_REQUEST_PENDING',
            SUCCESS: 'REGISTRATION_REQUEST_SUCCESS',
            FAILURE: 'REGISTRATION_REQUEST_FAILURE'
        },
        CAPTCHA: {
            RESET: 'CAPTCHA_REQUEST_RESET',
            PENDING: 'CAPTCHA_REQUEST_PENDING',
            SUCCESS: 'CAPTCHA_REQUEST_SUCCESS',
            FAILURE: 'CAPTCHA_REQUEST_FAILURE',
            VALIDATION: {
                RESET: 'CAPTCHA_VALIDATION_REQUEST_RESET',
                PENDING: 'CAPTCHA_VALIDATION_REQUEST_PENDING',
                SUCCESS: 'CAPTCHA_VALIDATION_REQUEST_SUCCESS',
                FAILURE: 'CAPTCHA_VALIDATION_REQUEST_FAILURE',
            }
        },
        HOME: {
            LOGIN: {
                RESET: 'LOGIN_REQUEST_RESET',
                PENDING: 'LOGIN_REQUEST_PENDING',
                SUCCESS: 'LOGIN_REQUEST_SUCCESS',
                FAILURE: 'LOGIN_REQUEST_FAILURE'
            },
            FORGOT: {
                RESET: 'FORGOT_REQUEST_RESET',
                PENDING: 'FORGOT_REQUEST_PENDING',
                SUCCESS: 'FORGOT_REQUEST_SUCCESS',
                FAILURE: 'FORGOT_REQUEST_FAILURE'
            },
            CHANGE: {
                RESET: 'CHANGE_REQUEST_RESET',
                PENDING: 'CHANGE_REQUEST_PENDING',
                SUCCESS: 'CHANGE_REQUEST_SUCCESS',
                FAILURE: 'CHANGE_REQUEST_FAILURE'
            },
            RESET: {
                RESET: 'RESET_REQUEST_RESET',
                PENDING: 'RESET_REQUEST_PENDING',
                SUCCESS: 'RESET_REQUEST_SUCCESS',
                FAILURE: 'RESET_REQUEST_FAILURE'
            }
        },
        CHECK: 'REQUEST_CHECK'
    },
    REGISTRATION: {
        SET_PERSONAL: 'SET_PERSONAL',
        SET_PASSPORT: 'SET_PASSPORT',
        SET_EMAIL: 'SET_EMAIL',
        SET_SECURITY: 'SET_SECURITY',
        SET_SIGNATURE: 'SET_SIGNATURE',
        SET_PROVIDER: 'SET_PROVIDER',
        SET_SUBMIT: 'SET_SUBMIT',
        SET_CAPTCHA_BASE64: 'SET_CAPTCHA_BASE64'
    },
    LOGIN: {
        SET_LOGIN: 'SET_LOGIN',
        SET_FORGOTTEN: 'SET_FORGOTTEN',
        SET_CHANGE_EMAIL: 'SET_CHANGE_EMAIL'
    }
}
